var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// class definition
import { LitElement, html } from '@horizon/base';
import { property } from '@horizon/base/decorators.js';
import StackStyles from './stack.css.js';
/**
 *
 * @tag hzn-stack
 * @tagname hzn-stack
 * @summary A layout component for vertically spacing child elements
 */
export class HznStack extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Set the flexbox gap between child elements
         */
        this.space = 'base';
        /**
         * Set the flexbox align-items along the x axis
         */
        this.alignX = 'start';
        /**
         * Set the flexbox justify-content along the y axis
         */
        this.alignY = 'start';
    }
    render() {
        return html `<slot></slot>`;
    }
}
HznStack.styles = [StackStyles];
__decorate([
    property({ type: String, reflect: true })
], HznStack.prototype, "space", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'align-x' })
], HznStack.prototype, "alignX", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'align-y' })
], HznStack.prototype, "alignY", void 0);
//# sourceMappingURL=stack.js.map